export default function MensagemParaTabelaSemDados(props) {
    return (
        <div className="text-center">
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">
                {props.mensagem}
            </p>
        </div>
    );
}